import { track } from "@/lib/track";
import { createContext, lazy, Suspense, useCallback, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ApplyModal = lazy(() => import("@/components/apply/ApplyModal"));
const ApplyContext = createContext(null);

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

export const ApplyProvider = ({ children }) => {
  const [loanType, setLoanType] = useState("");
  const [calcRate, setCalcRate] = useState(null);
  const [apply, setApply] = useState({ open: false, product: "", source: "", lender: "", session: 0 });
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const goTo = useCallback((id) => {
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollTo(id), 400);
    } else scrollTo(id);
  }, [pathname, navigate]);

  // Single entry point for every Apply button across the site
  const openApply = useCallback((productSlug = "", source = "", lender = "") => {
    track("apply_click", { product: productSlug, source: source || pathname, lender });
    setApply((s) => ({ open: true, product: productSlug || "", lender: lender || "", source: `apply_modal${source ? `:${source}` : ""}:${pathname}`, session: s.session + 1 }));
  }, [pathname]);

  const openCalculator = useCallback((rate = null) => {
    setCalcRate(rate);
    goTo("emi-calculator");
  }, [goTo]);

  return (
    <ApplyContext.Provider value={{ loanType, setLoanType, calcRate, openApply, openCalculator, goTo }}>
      {children}
      {apply.session > 0 && (
        <Suspense fallback={null}>
          <ApplyModal open={apply.open} product={apply.product} source={apply.source} lender={apply.lender} session={apply.session}
            onOpenChange={(open) => setApply((s) => ({ ...s, open }))} />
        </Suspense>
      )}
    </ApplyContext.Provider>
  );
};

export const useApply = () => useContext(ApplyContext);
